import { type OrgParams, useGetQuery, usePatchQuery, useRouteParams } from "@quortex/front-common"
import type { DeepPartial } from "react-hook-form"
import type { WorkspaceParams } from "@/queries/types"

//--------------------------------------------------------------------------------------------------
// URLs
//--------------------------------------------------------------------------------------------------

/** @returns /workspaces/?org=${orgUuid} */
const getWorkspaceListUrl = ({ orgUuid }: Required<OrgParams>) => `/workspaces/?org=${orgUuid}`

/** @returns /workspaces/${WorkspaceUuid}/?org=${orgUuid} */
const getWorkspaceUrl = ({ orgUuid, workspaceUuid }: Required<WorkspaceParams>) =>
  `/workspaces/${workspaceUuid}/?org=${orgUuid}`

//--------------------------------------------------------------------------------------------------
// Queries & mutations
//--------------------------------------------------------------------------------------------------

export const useWorkspaceList = (params?: OrgParams) => {
  const mergedParams = useRouteParams(params)
  const listUrl = getWorkspaceListUrl(mergedParams)

  return useGetQuery<api.switchns.PaginatedWorkspaceList>("switch", listUrl)
}

export const useUpdateWorkspace = (params?: WorkspaceParams) => {
  const mergedParams = useRouteParams(params)
  const url = getWorkspaceUrl(mergedParams)
  const listUrl = getWorkspaceListUrl(mergedParams)

  type TRequest = DeepPartial<api.switchns.Workspace>
  type TResponse = api.switchns.Workspace

  return usePatchQuery<TRequest, TResponse>("switch", url, [listUrl])
}
